// SETUP COLORS
export const GREY = {
    0: '#FFFFFF',
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24'
};

export const VIOLET = {
    100: '#bbb2ff',
    200: '#625e81',
    300: '#543efa',
    400: '#4c4c72',
    500: '#4733dc',
    600: '#252550',
    700: '#1d174a',
    800: '#151529'
};

export const MAGENTA = {
    100: '#f580f7',
    200: '#ab27ad'
};
export const LIME = {
    100: '#bef941'
};
export const BLUE = {
    100: '#007aff'
};
